import React from 'react'
// import { useNavigate } from "react-router";
import './Gamelist.css'
import getNum from '../../../method/method'

export default function Gamelist({ gamelist }) {
  // const navigate = useNavigate()
  // /* 跳转详情 */
  // const goDetails = (para) => {
  //     window.location = '/page/details?gid=' + para
  // }
  return (
    <div className="nav-content">
      <h1>New Games</h1>
      <div className="gl-content">
        {/* 游戏列表区 */}

        <ul>
          {gamelist?.map(item => (
            <li key={item.gid}>
              <a href={'/page/details?gid=' + item.gid} className="dis_a">
                <div>
                  <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                  <div className="load">
                    <h2>{item.name}</h2>
                    {/*<p>{item.type}</p>*/}
                    <span>{getNum(item.count)}</span>
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
